module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "usergroup-form"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Live Quiz',
          to: {
            path: '/addlivequiz'
          },
          exact: true,
        },
        {
          text: !_vm.$route.query.id ?
            'Tambah Sesi Live Quiz' :
            'Ubah Sesi Live Quiz',
        } ],
      "divider": ">"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("\n        " + _vm._s(!_vm.$route.query.id ? "Tambah Sesi" : "Ubah Sesi") + "\n    ")]), _vm._v(" "), _c('v-card', {
    staticClass: "pa-4",
    attrs: {
      "plain": ""
    }
  }, [_c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Nama Sesi\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Nama Sesi",
      "outlined": ""
    },
    model: {
      value: (_vm.form.session_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "session_name", $$v)
      },
      expression: "form.session_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Teacher\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "live_class_mapel",
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Pilih Teacher",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }]),
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Mata Pelajaran\n                ")]), _vm._v(" "), _c('v-select', {
    staticClass: "pa-0",
    attrs: {
      "id": "live_class_mapel",
      "items": _vm.mapelList,
      "outlined": "",
      "item-text": "nama",
      "item-value": "id",
      "placeholder": "Pilih mata pelajaran",
      "chips": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item', {
          staticClass: "pa-0 ma-0"
        }, [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])], 1)]
      }
    }, {
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-list-item-avatar', [_c('img', {
          attrs: {
            "src": item.picture
          }
        })]), _vm._v(" "), _c('v-list-item-title', [_vm._v(_vm._s(item.nama))])]
      }
    }]),
    model: {
      value: (_vm.form.mapel),
      callback: function($$v) {
        _vm.$set(_vm.form, "mapel", $$v)
      },
      expression: "form.mapel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kuota\n                ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "placeholder": "Jumlah kuota",
      "outlined": ""
    },
    model: {
      value: (_vm.form.session_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "session_name", $$v)
      },
      expression: "form.session_name"
    }
  })], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Jenjang *\n                ")]), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    on: {
      "change": function($event) {
        _vm.form.grade = []
      }
    },
    model: {
      value: (_vm.form.level),
      callback: function($$v) {
        _vm.$set(_vm.form, "level", $$v)
      },
      expression: "form.level"
    }
  }, [_c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_sd",
      "label": "SD",
      "value": "SD",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_smp",
      "label": "SMP",
      "value": "SMP",
      "active-class": "act-radio-btn"
    }
  }), _vm._v(" "), _c('v-radio', {
    staticClass: "jenjang-selection",
    attrs: {
      "id": "live_class_jenjang_sma",
      "label": "SMA",
      "value": "SMA",
      "active-class": "act-radio-btn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-list-item', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', {
    staticClass: "pa-0"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                    Kelas *\n                ")]), _vm._v(" "), (_vm.form.level === 'SD') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_1",
      "label": "1",
      "value": 1,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_2",
      "label": "2",
      "value": 2,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_3",
      "label": "3",
      "value": 3,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_4",
      "label": "4",
      "value": 4,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_5",
      "label": "5",
      "value": 5,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_6",
      "label": "6",
      "value": 6,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMP') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_7",
      "label": "7",
      "value": 7,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_8",
      "label": "8",
      "value": 8,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_9",
      "label": "9",
      "value": 9,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.level === 'SMA') ? _c('div', {
    staticClass: "d-inline"
  }, [_c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_10",
      "label": "10",
      "value": 10,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_11",
      "label": "11",
      "value": 11,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    staticClass: "pa-2 ma-0 d-inline-flex",
    attrs: {
      "id": "live_class_kelas_12",
      "label": "12",
      "value": 12,
      "outlined": ""
    },
    model: {
      value: (_vm.form.grade),
      callback: function($$v) {
        _vm.$set(_vm.form, "grade", $$v)
      },
      expression: "form.grade"
    }
  })], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-list-item', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "pa-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Mulai *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "live_class_start_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "outlined": ""
          },
          model: {
            value: (
              _vm.startDate.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.startDate, "value", $$v)
            },
            expression: "\n                                                        startDate.value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startDate.option),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "option", $$v)
      },
      expression: "startDate.option"
    }
  }, [_vm._v(" "), (_vm.startDate.option) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(0, 10),
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.startDate.option = false
      }
    },
    model: {
      value: (_vm.startDate.value),
      callback: function($$v) {
        _vm.$set(_vm.startDate, "value", $$v)
      },
      expression: "startDate.value"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "live_class_start_time",
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline"
          },
          model: {
            value: (
              _vm.startTime.value
            ),
            callback: function($$v) {
              _vm.$set(_vm.startTime, "value", $$v)
            },
            expression: "\n                                                        startTime.value\n                                                    "
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.startTime.option),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "option", $$v)
      },
      expression: "startTime.option"
    }
  }, [_vm._v(" "), (_vm.startTime.option) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.startTime.option = false
      }
    },
    model: {
      value: (_vm.startTime.value),
      callback: function($$v) {
        _vm.$set(_vm.startTime, "value", $$v)
      },
      expression: "startTime.value"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-list-item', {
    staticClass: "py-0 px-1",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', {
    staticClass: "font-weight-bold pb-2"
  }, [_vm._v("\n                                Waktu Berakhir *\n                            ")]), _vm._v(" "), _c('v-container', [_c('v-row', [_c('v-col', {
    staticClass: "pa-0",
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "live_class_end_date",
            "append-icon": "mdi-calendar",
            "placeholder": "Tanggal",
            "outlined": ""
          },
          model: {
            value: (_vm.endDate.value),
            callback: function($$v) {
              _vm.$set(_vm.endDate, "value", $$v)
            },
            expression: "endDate.value"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endDate.option),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "option", $$v)
      },
      expression: "endDate.option"
    }
  }, [_vm._v(" "), (_vm.endDate.option) ? _c('v-date-picker', {
    attrs: {
      "min": new Date()
        .toISOString()
        .slice(0, 10),
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "change": function($event) {
        _vm.endDate.option = false
      }
    },
    model: {
      value: (_vm.endDate.value),
      callback: function($$v) {
        _vm.$set(_vm.endDate, "value", $$v)
      },
      expression: "endDate.value"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "transition": "slide-y-reverse-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-text-field', _vm._g(_vm._b({
          attrs: {
            "id": "live_class_end_time",
            "outlined": "",
            "placeholder": "Jam",
            "append-icon": "mdi-clock-time-four-outline"
          },
          model: {
            value: (_vm.endTime.value),
            callback: function($$v) {
              _vm.$set(_vm.endTime, "value", $$v)
            },
            expression: "endTime.value"
          }
        }, 'v-text-field', attrs, false), on))]
      }
    }]),
    model: {
      value: (_vm.endTime.option),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "option", $$v)
      },
      expression: "endTime.option"
    }
  }, [_vm._v(" "), (_vm.endTime.option) ? _c('v-time-picker', {
    attrs: {
      "format": "24hr"
    },
    on: {
      "change": function($event) {
        _vm.endTime.option = false
      }
    },
    model: {
      value: (_vm.endTime.value),
      callback: function($$v) {
        _vm.$set(_vm.endTime, "value", $$v)
      },
      expression: "endTime.value"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "py-2"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/addlivequiz'
        })
      }
    }
  }, [_vm._v("\n                Batal\n            ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        !_vm.$route.query.id ? _vm.saveData() : _vm.editData()
      }
    }
  }, [_vm._v("\n                Simpan\n            ")])], 1)], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d036ff3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/omnilearning/components/AddLiveQuizForm.vue
// module id = 1957
// module chunks = 1